<div class="mat-simple-snackbar">
  <span [innerHTML]="data.message"></span>
  <div class="mat-simple-snackbar-action ng-star-inserted">
    <button
      mat-button
      class="mat-button mat-button-base"
      (click)="snackBar.dismiss()"
    >
      <span class="mat-button-wrapper">{{ data.action }}</span>
      <div
        matripple
        class="mat-ripple mat-button-ripple"
        ng-reflect-disabled="false"
        ng-reflect-centered="false"
      ></div>
      <div class="mat-button-focus-overlay"></div>
    </button>
  </div>
</div>
